// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"54bb5762","525":"bcf79393","830":"6da0d5f3","874":"d2f5f10f"}[chunkId] + ".chunk.css";
};